import { JustificativaModal } from '@components/Modal/JustificativaModal';
import { IForm } from '@hooks/useForm';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IJustificativaRequest } from '@hooks/useRequest';
import { IClienteEvento } from '@model/ClienteEvento';
import { useClienteEventoService } from '@services/ClienteEventoService';
import { AxiosResponse } from 'axios';
import React from 'react';

export type EventoCancelarModalProps = {
    clienteEvento: IClienteEvento
    modal: IModalWindow
    onEventoCancelado: (response: AxiosResponse<IClienteEvento>) => void
}

export function EventoCancelarModal ({ clienteEvento, modal, onEventoCancelado }: EventoCancelarModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const clienteEventoService = useClienteEventoService();

    const handleConfirm = React.useCallback((values: IJustificativaRequest, form: IForm<IJustificativaRequest>) => {
        if (!loading.isLoading) {
            loading.start();
            clienteEventoService.cancelar(clienteEvento.clienteEventoId, values)
                .then(response => {
                    message.success("Evento cancelado com sucesso");
                    modal.close();
                    onEventoCancelado(response);
                })
                .catch(e => {
                    message.handleResponse(e)
                        .badRequest(form.setErrorsFromServer)
                        .showException();
                })
                .finally(loading.stop);
        }
    }, [clienteEvento.clienteEventoId, clienteEventoService, loading, message, modal, onEventoCancelado])

    return (
        <JustificativaModal
            confirmText="Cancelar Evento"
            disabled={loading.isLoading}
            modal={modal}
            onConfirm={handleConfirm}
            title={`Cancelamento do Evento ${clienteEvento.clienteEventoId}`}
        />
    )
}